import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';

export interface AppClientMeta {
  appVersion?: string | null;
  appBuild?: string | null;
  platform?: string | null;
  osVersion?: string | null;
  deviceModel?: string | null;
}

export async function collectAppClientMeta(): Promise<AppClientMeta> {
  let appVersion: string | null = null;
  let appBuild: string | null = null;
  let platform: string | null = Capacitor.getPlatform() || null;
  let osVersion: string | null = null;
  let deviceModel: string | null = null;

  try {
    const appInfo = await App.getInfo();
    appVersion = appInfo.version ?? null;
    appBuild = appInfo.build ?? null;
  } catch {
    // App.getInfo is unavailable on web.
  }

  try {
    const deviceInfo = await Device.getInfo();
    platform = deviceInfo.platform || platform;
    osVersion = deviceInfo.osVersion ?? null;
    deviceModel = deviceInfo.model ?? null;
  } catch {
    // Device plugin may be missing on web/dev.
  }

  return {
    appVersion,
    appBuild,
    platform,
    osVersion,
    deviceModel,
  };
}

export const APP_CLIENT_HTTP_HEADERS = {
  appVersion: 'X-Spotcharge-App-Version',
  appBuild: 'X-Spotcharge-App-Build',
  platform: 'X-Spotcharge-Platform',
  osVersion: 'X-Spotcharge-Os-Version',
  deviceModel: 'X-Spotcharge-Device-Model',
} as const;

export function appClientMetaToHttpHeaders(meta: AppClientMeta): Record<string, string> {
  const headers: Record<string, string> = {};
  if (meta.appVersion) {
    headers[APP_CLIENT_HTTP_HEADERS.appVersion] = meta.appVersion;
  }
  if (meta.appBuild) {
    headers[APP_CLIENT_HTTP_HEADERS.appBuild] = meta.appBuild;
  }
  if (meta.platform) {
    headers[APP_CLIENT_HTTP_HEADERS.platform] = meta.platform;
  }
  if (meta.osVersion) {
    headers[APP_CLIENT_HTTP_HEADERS.osVersion] = meta.osVersion;
  }
  if (meta.deviceModel) {
    headers[APP_CLIENT_HTTP_HEADERS.deviceModel] = meta.deviceModel;
  }
  return headers;
}
